import { removeTags } from "../../../../../../utils/Constans";
import "./CategoryDetailViewTextComponent.scss";
import PropTypes from "prop-types";

/**
 * @function CategoryDetailViewTextComponent CategoryDetailViewTextComponent
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
 */
const CategoryDetailViewTextComponent = ({ info }) => {
    return (
        <div role="contentinfo" tabIndex="0" aria-label={removeTags(info)}  className="CategoryDetailViewTextComponent" dangerouslySetInnerHTML={ { __html: info } }></div>
    );
};

CategoryDetailViewTextComponent.propTypes = {
    info: PropTypes.string.isRequired,
};

CategoryDetailViewTextComponent.defaultProps = {
    info: "",
};

export default CategoryDetailViewTextComponent;